
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHistoryGoogle as ObiHistoryGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-history-google.js';
 
 
 

 
 export const ObiHistoryGoogle = createComponent({
   react: React,
   tagName: 'obi-history-google',
   elementClass: ObiHistoryGoogleElement,
   events: {
     
   }
  });
 
 